import styled from 'styled-components'

interface ISingleFileViewerUploadEmptyStateStyledProps {}

export const SingleFileViewerUploadEmptyStateStyled = styled.div<ISingleFileViewerUploadEmptyStateStyledProps>`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  .fileviewer-emptystate-container {
    width: 75%;
    height: 75%;

    display: flex;
    align-items: center;
    justify-content: center;

    background: radial-gradient(
      ${(props) => props.theme.colors.selected},
      transparent 60%
    );
  }

  text-align: center;
`
